// Global iCoach service — API calls survive component unmount
import { aiAPI } from '../services/api';

let pendingRequest = null;

function getUserId() {
  return localStorage.getItem('userId') || 'anonymous';
}

function getKey(base) {
  return `${base}_${getUserId()}`;
}

const iCoachService = {
  sendMessage: (text, sessionId) => {
    pendingRequest = {
      status: 'loading',
      text,
      sessionId,
      promise: null,
    };

    pendingRequest.promise = aiAPI.chat(text, sessionId)
      .then((response) => {
        const { message, sessionId: newSessionId, imageUrl } = response.data;
        try {
          const saved = JSON.parse(localStorage.getItem(getKey('icoach_messages')) || '[]');
          for (let i = saved.length - 1; i >= 0; i--) {
            if (saved[i].type === 'ai' && !saved[i].isComplete) {
              saved[i].text = message;
              saved[i].imageUrl = imageUrl || null;
              saved[i].isComplete = true;
              break;
            }
          }
          localStorage.setItem(getKey('icoach_messages'), JSON.stringify(saved));
          if (newSessionId) {
            localStorage.setItem(getKey('icoach_sessionId'), newSessionId);
          }
        } catch {}

        pendingRequest = {
          status: 'done',
          result: { message, sessionId: newSessionId, imageUrl },
        };
        return { message, sessionId: newSessionId, imageUrl };
      })
      .catch((error) => {
        pendingRequest = { status: 'error', error };
        throw error;
      });

    return pendingRequest.promise;
  },

  consumePending: () => {
    if (pendingRequest && pendingRequest.status === 'done') {
      const result = pendingRequest.result;
      pendingRequest = null;
      return result;
    }
    return null;
  },

  isLoading: () => pendingRequest?.status === 'loading',

  clear: () => {
    pendingRequest = null;
  },

  getKey,
};

export default iCoachService;
